module.exports = __webpack_public_path__ + "media/assets/images/flags/sm-0eb66e7b01c4d88850e089b4cab58a3e.svg";